import React, { useState } from "react";
import { Stack } from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import ReusableInput from "components/Inputs/ReusableInput";
import GradientButton from "components/Buttons/GradientButton";

const AdminTopUpWalletDrawer = ({ isOpen, onClose, driver, onTopUp }) => {
  const [amount, setAmount] = useState("");

  const handleSubmit = () => {
    onTopUp({
      driver_id: driver?.driver?.driver_id,
      amount: Number(amount),
    });

    setAmount("");
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={
        <h2>
          Complimentary Wallet Top-up for {driver?.user?.first_name}{" "}
          {driver?.user?.last_name}
        </h2>
      }
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Amount (P)"
            name="amount"
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row">
          <GradientButton onClick={onClose} height="37px" fontSize="13px">
            Cancel
          </GradientButton>

          <GradientButton onClick={handleSubmit} height="37px" fontSize="13px">
            Top Up Wallet
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default AdminTopUpWalletDrawer;
